import { getTicketsStatuses } from "library/api/zendesk/zendesk";
import { ZendeskStatus } from "library/zendeskAPI/types";
import {
  getLeastAdvancedStatus,
  getRequests,
} from "library/zendeskAPI/zendeskUtils";

export const REQUEST_STATUSES: {
  [key: string]: RequestStatusType;
} = {
  NOT_REQUESTED: "Not requested",
  SUBMITTED: "Submitted",
  IN_PROGRESS: "In progress",
  COMPLETED: "Completed",
};

export type RequestStatusType =
  | "Not requested"
  | "Submitted"
  | "In progress"
  | "Completed";

const getRequestStatusFromZendeskStatus = (
  zendeskStatus: ZendeskStatus,
): RequestStatusType =>
  zendeskStatus === "new"
    ? REQUEST_STATUSES.SUBMITTED
    : ["open", "pending", "hold"].includes(zendeskStatus)
    ? REQUEST_STATUSES.IN_PROGRESS
    : ["solved", "closed"].includes(zendeskStatus)
    ? REQUEST_STATUSES.COMPLETED
    : REQUEST_STATUSES.NOT_REQUESTED;

type Params = { userEmail: string; accountNumber: string; requestType: string };

export const getRequestStatus = async (
  { userEmail, accountNumber, requestType }: Params,
  token: string,
): Promise<RequestStatusType> => {
  const requests = getRequests({
    userEmail,
    accountNumber,
    requestType,
  });

  if (requests.length === 0) {
    return REQUEST_STATUSES.NOT_REQUESTED;
  }

  const statuses = await getTicketsStatuses(requests, token);
  const status = getLeastAdvancedStatus(statuses);

  return getRequestStatusFromZendeskStatus(status);
};
